import styled from "styled-components";

export const StyledErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
  background-color: #f8f9fa;
  color: #333;
`;

export const StyledErrorMessage = styled.div`
  margin-bottom: 2rem;

  h1 {
    color: #dc3545;
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
    color: #6c757d;
    margin-bottom: 0;
  }
`;

export const StyledRetryButton = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-bottom: 2rem;

  &:hover {
    background-color: #0056b3;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const StyledErrorDetails = styled.div`
  max-width: 800px;
  width: 100%;
  text-align: left;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 1.5rem;

  h3 {
    color: #dc3545;
    margin-bottom: 1rem;
  }

  details {
    margin-bottom: 1rem;
    border: 1px solid #e9ecef;
    border-radius: 0.25rem;
    overflow: hidden;

    summary {
      padding: 0.75rem;
      background-color: #f8f9fa;
      cursor: pointer;
      font-weight: 600;
      border-bottom: 1px solid #e9ecef;

      &:hover {
        background-color: #e9ecef;
      }
    }

    pre {
      margin: 0;
      padding: 1rem;
      background-color: #f8f9fa;
      font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
      font-size: 0.875rem;
      line-height: 1.4;
      overflow-x: auto;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
`;
